import React, {Component} from 'react';
import {View, Text} from 'react-native';

export default class Projects extends Component {
  render() {
    return (
      <View>
        <Text>Here are the projects </Text>
      </View>
    );
  }
}
